import FactoryPageSelected from './FactoryPageSelected'

export default FactoryPageSelected
